import script from "./TranslatorCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TranslatorCard.vue?vue&type=script&setup=true&lang=js"

import "./TranslatorCard.vue?vue&type=style&index=0&id=3e7585e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e7585e0"]])

export default __exports__